
const initialState = {
    revenue: {},
    revenuesStaff: [],
    staff: [],
    detailStaff: {},
    paging: {
      staff: {
        start: 0,
        limit: 10,
      }
    },
    count: {
      staff: 0,
    }
};

export default function wageFund(state = initialState, action) {
    switch(action.type) {
      case 'SET_WAGE_FUND': {
        return {
            ...state,
            [action.field]: action.data
        };
      }
      case 'ADD_WAGE_FUND': {
            return {
                ...state,
                [action.field]: [...state[action.field], action.data]
            };
      }
      case 'DELETE_WAGE_FUND': {
            return {
                ...state,
                [action.field]: state[action.field].filter((item) => item.id !== action.id)
            };
      }
      case 'SET_WAGE_FUND_COUNT': {
        return {
          ...state,
          count: {
            ...state.count,
            [action.field]: action.count
          }
        };
      }
      case 'SET_WAGE_FUND_PAGING': {
        return {
          ...state,
          paging: {
            ...state.paging,
            [action.field]: action.paging
          }
        };
      }
    default: return state;
    }
  }